import { ErrorCode } from './ErrorCode'

export const errorMessages: Record<ErrorCode, string> = {
  [ErrorCode.UNKNOWN]: 'Ein unbekannter Fehler ist aufgetreten.',
  [ErrorCode.NETWORK]: 'Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung.',
  [ErrorCode.GRAPHQL]: 'Ein Fehler ist beim Abrufen der Daten aufgetreten.',
  [ErrorCode.VALIDATION]: 'Die eingegebenen Daten sind nicht gültig.',
  [ErrorCode.AUTH]: 'Sie sind nicht berechtigt, diese Aktion auszuführen.',
  [ErrorCode.NOT_FOUND]: 'Die angeforderte Seite konnte nicht gefunden werden.',
  [ErrorCode.PAYMENT]: 'Ein Fehler ist bei der Zahlung aufgetreten.',
  [ErrorCode.FILE_UPLOAD]:
    'Ein Fehler ist beim Hochladen der Datei aufgetreten.',
}
